import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { fragments } from '@/hooks/fragments'
import { Mutation, MutationUpdateStorageFacilityArgs } from '@/schemaTypes'

const UPDATE_STORAGE_FACILITY = gql`
  mutation updateStorageFacility(
    $name: String!
    $external: Boolean!
    $address: IAddress!
    $_id: ObjectId!
  ) {
    updateStorageFacility(
      name: $name
      external: $external
      address: $address
      _id: $_id
    ) {
      _id
      name
      external
      address {
        ...AddressFragment
      }
    }
  }
  ${fragments.address}
`

type TData = { updateStorageFacility: Mutation['updateStorageFacility'] }
type TVariables = MutationUpdateStorageFacilityArgs

export function useUpdateStorageFacility(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  const [updateStorageFacility] = useMutation<TData, TVariables>(
    UPDATE_STORAGE_FACILITY,
    opts,
  )

  return updateStorageFacility
}
